import { useCallback, useEffect, useState } from 'react';
import useNavigateWithSearch from '../../../../hooks/useNavigateWithSearch';

import { ROUTE_MEMBERSHIP, ROUTE_MY_ACCOUNT } from '../../config/routes';
import PageContent from '../../global/PageContent';
import { Button, BUTTON_SIZE, BUTTON_TYPE } from '../../global/Button';
import { getGenericError } from '../../utils/errors';
import { getSubscriptionsOrders } from '../../utils/service';
import TBBGroupFront from '../../images/tbb-group-front.png';
import MembershipOrdersList from './MembershipOrdersList';

import './MembershipOrders.scss';

const MembershipOrders = () => {
  const navigateWithSearch = useNavigateWithSearch();

  const [listData, setListData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  const loadOrders = useCallback(async () => {
    setIsLoading(true);

    const {
      data,
      error: ordersError,
    } = await getSubscriptionsOrders();

    if (ordersError) {
      setListData([]);
      setError(ordersError.message ?? getGenericError());
      setIsLoading(false);
      return;
    }

    setListData(data?.orders ?? []);
    setIsLoading(false);
  }, []);

  useEffect(() => {
    loadOrders();
  }, []);

  return (
    <PageContent
      title="Membership Activity"
      isLoading={isLoading}
      error={error}
      className="MembershipOrders"
      backButtonText="GO TO MY ACCOUNT"
      parentUrl={ROUTE_MY_ACCOUNT}
    >
      {listData.length > 0 ? (
        <MembershipOrdersList listData={listData} />
      ) : (
        <div className="MembershipOrders__noData">
          <img className="MembershipOrders__noData--image" src={TBBGroupFront} alt="TBB Group Front" />
          <span className="MembershipOrders__noData--message">
            You have Unlimited Recycling for Clothes & Electronics
          </span>
          <div className="MembershipOrders__noData--buttons">
            <Button
              type={BUTTON_TYPE.QUATERNARY}
              size={BUTTON_SIZE.LARGE}
              onClick={() => navigateWithSearch(ROUTE_MEMBERSHIP)}
            >
              View your membership dashboard
            </Button>
          </div>
        </div>
      )}
    </PageContent>
  );
};

export default MembershipOrders;
